export default __webpack_public_path__ + "static/poll_and_scheduling-e07b1708c9dbb8ac4170faf1d854eda0.svg";